import { Controller } from "stimulus"

const sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;
// only need to run this on first page load
export default class AnalyticsController extends Controller {

  first
  session

  static get targets() {
    return []
  }

  firstTooOld() {
    // always too old
    if (!this.first) return true
    const old = new Date().getTime() - sixMonths
    return this.first.timestamp <= old
  }

  saveFirst() {
    localStorage.setItem('analytics/first', JSON.stringify(this.first))
  }
  saveSession() {
    sessionStorage.setItem('analytics/session', JSON.stringify(this.session))
  }


  getEntrypoint() {
    const canonicalTag = document.querySelector("link[rel='canonical']")
    return canonicalTag ? canonicalTag.getAttribute("href") : window.location.href;
  }

  initialize() {
    this.first = JSON.parse(localStorage.getItem('analytics/first') || null)
    this.session = JSON.parse(sessionStorage.getItem('analytics/session') || null)

    const hit = {
      referrer: document.referrer === "" ? null : document.referrer,
      entrypoint: this.getEntrypoint(),
      timestamp: new Date().getTime()
    }
    if (window.isDevelopment) {
      console.log("[analytics] payload", hit)
    }
    
    if (this.firstTooOld()) {
      this.first = {...hit}
      this.saveFirst()
      // console.log("[analytics] saving as FIRST")
    }

    if (!this.session) {
      this.session = {...hit}
      this.saveSession()
      // console.log("[analytics] saving as SESSION FIRST")
    }


  }
}